import {
  CloseCircleOutlined,
  PlusCircleFilled,
  SearchOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  Form,
  Input,
  Layout,
  message,
  Row,
  Table,
  Tooltip,
} from "antd";
import { useForm } from "antd/lib/form/Form";
import React, { useEffect, useState } from "react";
import search from "../../helpers/search";
import useSpaceShareSettings from "../../hooks/useSpaceShareSettings";
import { space_share_setting_default } from "./types";
import { spaceShareSettingsService } from "../../services/SpaceShareSettingsService";
import SpaceShareSettingsForm from "../SpaceShareSettingsPage/SpaceShareSettingsForm";
import moment from "moment";

const { Header, Content } = Layout;

export const getFullDate = (date: string): string => {
  const dateAndTime = date.split("T");
  //return dateAndTime[0];
  //return dateAndTime[0].split("-").reverse().join("-");
  let format_date = moment.utc(date).local();
  return format_date.format("YYYY-MM-DD");
};

const columns = [
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
    render: (date: string) => getFullDate(date),
  },
  {
    title: "Manufacturer",
    dataIndex: "manufacturer_name",
    key: "manufacturer_name",
  },
  {
    title: "Country",
    dataIndex: "country_name",
    key: "country_name",
  },
  {
    title: "Category",
    dataIndex: "category_name",
    key: "category_name",
  },
];
const SpaceShareSettingsPage: React.FC = function () {
  const [form] = useForm();
  const [searching, setSearching] = useState(false);
  const [visible, setVisible] = useState(false);
  const [channelsToDisplay, setChannelsToDisplay] = useState([]);
  const [state, setState] = useState({
    isCreate: false,
    selected: space_share_setting_default,
    data: [],
    pagination: {
      current: 1,
      pageSize: 10,
      total: 0,
    },
    pagination_search: {
      current: 1,
      pageSize: 10,
      total: 0,
    },
  });
  const [channels, loadingChannels] = useSpaceShareSettings(
    state.pagination.current
  );
  const onSearch = async (key: string) => {
    const searchWord = await form.getFieldValue("searchWord");
    if (!searchWord) {
      message.error("Please enter a valid search string!");
      return;
    }

    setSearching(true);
    // made array to cater more query types in future
    const searchData = [
      {
        key,
        value: encodeURIComponent(searchWord),
        collection: "space_share_settings",
      },
    ];

    const searchedData = await search(
      searchData,
      spaceShareSettingsService,
      key
    );
    setChannelsToDisplay(searchedData.data);
    setState({
      ...state,
      pagination_search: {
        ...state.pagination_search,
        total: searchedData.total,
        current: 1,
      },
    });
    setSearching(false);
  };

  const onClose = async () => {
    const searchWord = await form.getFieldValue("searchWord");

    setState({
      ...state,
    });
    setSearching(true);
    if (searchWord) {
      const searchData = [
        {
          key: "manufacturer_name",
          value: encodeURIComponent(searchWord),
          collection: "space_share_settings",
        },
      ];

      const searchedData = await search(
        searchData,
        spaceShareSettingsService,
        "manufacturer_name"
      );
      setChannelsToDisplay(searchedData.data);
    } else {
      const searchedData = await spaceShareSettingsService.getAll(
        state.pagination.current
      );
      const data_channelsToDisplay = searchedData.data.space_share_settings
        ? searchedData.data.space_share_settings
        : channels;
      setChannelsToDisplay(data_channelsToDisplay);
    }

    setSearching(false);
  };

  const onSubmit = () => { };

  const handleTableChange = async (pagination: any) => {
    setSearching(true);
    setState({
      ...state,
      data: [],
      pagination: pagination,
    });
    const data = await spaceShareSettingsService.getAll(pagination.current);
    setChannelsToDisplay(data.data.space_share_settings);
    setSearching(false);
  };

  const handleTableSearchChange = async (pagination: any) => {
    const searchWord = await form.getFieldValue("searchWord");

    setSearching(true);
    setState({
      ...state,
      data: [],
      pagination_search: pagination,
    });
    const searchData = [
      {
        key: "manufacturer_name",
        value: encodeURIComponent(searchWord),
        page: pagination.current,
        collection: "space_share_settings",
      },
    ];

    const data = await search(
      searchData,
      spaceShareSettingsService,
      "manufacturer_name"
    );
    setChannelsToDisplay(data.data);
    setSearching(false);
  };

  useEffect(() => {
    setChannelsToDisplay(channels.space_share_settings);
    setState({
      ...state,
      pagination: {
        ...state.pagination,
        total: channels.total,
      },
    });
  }, [channels]);

  const loading = searching || loadingChannels;

  return (
    <Layout style={{ padding: 20 }}>
      <Header
        style={{
          textAlign: "left",
          backgroundColor: "#F0F2F5",
          padding: 0,
          borderRadius: 15,
        }}
      >
        <Row>
          <Col span={12}>
            <h3 style={{ fontWeight: "bold", paddingLeft: 0 }}>
              Space Share Settings
            </h3>
          </Col>
          <Col span={12} style={{ textAlign: "right", paddingRight: 0 }}>
            <Button
              onClick={() => {
                setVisible(true);
                setState({
                  ...state,
                  isCreate: true,
                  selected: space_share_setting_default,
                });
              }}
              type="primary"
              shape="round"
              icon={<PlusCircleFilled />}
              style={{ width: 150 }}
            >
              Add New
            </Button>
          </Col>
        </Row>
      </Header>
      <Content>
        <Row
          style={{
            textAlign: "left",
            backgroundColor: "white",
            padding: 20,
            borderRadius: 10,
            marginTop: 0,
          }}
        >
          <Col span={24}>
            <Row>
              <Col span={24} style={{ fontWeight: "bold" }}>
                What are you looking for?
              </Col>
            </Row>
            <Row style={{ marginTop: 20 }}>
              <Form
                form={form}
                initialValues={{ searchWord: "" }}
                style={{
                  fontWeight: "bold",
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  flexWrap: "wrap",
                }}
                onValuesChange={(changedVals) => {
                  if (changedVals.searchWord === "") {
                    onClose();
                  }
                }}>
                <Col>
                  <Form.Item name="searchWord">
                    <Input
                      style={{ width: 300, borderRadius: 10 }}
                      placeholder={"Search"}
                      prefix={<SearchOutlined style={{ color: "#ccc" }} />}
                      suffix={
                        <Tooltip title="Clear Search">
                          <CloseCircleOutlined
                            onClick={() => {
                              setChannelsToDisplay(channels.space_share_settings);
                              setState({
                                ...state,
                                isCreate: false,
                                pagination: {
                                  current: 1,
                                  pageSize: 10,
                                  total: channels.total,
                                },
                              });
                              form.setFieldsValue({
                                searchWord: ""
                              })
                              form.resetFields(["search"]);
                            }}
                            style={{
                              color: "rgba(0,0,0,.45)",
                            }}
                          />
                        </Tooltip>
                      }
                    ></Input>
                  </Form.Item>

                </Col>
                <Col style={{ textAlign: "right", paddingRight: 0 }}>
                  <Form.Item>
                    <Button
                      type="primary"
                      shape="round"
                      htmlType="submit"
                      onClick={() => onSearch("manufacturer_name")}
                      style={{ width: 200 }}
                    >
                      Search By Manufacturer
                    </Button>
                  </Form.Item>

                </Col>
              </Form>

            </Row>
          </Col>
        </Row>
        <Row
          style={{
            padding: 20,
            backgroundColor: "white",
            marginTop: 20,
            borderRadius: 15,
          }}
        >
          <Col span={24}>
            {!form.getFieldValue("searchWord") ? (
              <Table
                //pagination={{ position: ["bottomRight", "topRight"] }}
                pagination={state.pagination}
                loading={loading}
                onRow={(record, _) => {
                  return {
                    onClick: () => {
                      setState({
                        ...state,
                        isCreate: false,
                        selected: record,
                      });
                      setVisible(true);
                    },
                  };
                }}
                dataSource={channelsToDisplay}
                columns={columns}
                onChange={handleTableChange}
              />
            ) : (
              <Table
                //pagination={{ position: ["bottomRight"] }}
                pagination={state.pagination_search}
                loading={loading}
                onRow={(record, _) => {
                  return {
                    onClick: () => {
                      setState({
                        ...state,
                        isCreate: false,
                        selected: record,
                      });
                      setVisible(true);
                      // console.log(record);
                    },
                  };
                }}
                dataSource={channelsToDisplay}
                columns={columns}
                onChange={handleTableSearchChange}
              />
            )}
          </Col>
        </Row>
      </Content>
      <SpaceShareSettingsForm
        visible={visible}
        form={form}
        values={{
          ...state.selected,
        }}
        isChanged={false}
        setVisible={setVisible}
        isCreate={state.isCreate}
        onClose={onClose}
      />
    </Layout>
  );
};

export default SpaceShareSettingsPage;
